import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
// Dynamic-import Componects
const Home = () => import('@/components/Home');
const Login = () => import('@/components/user/Login');
const Register = () => import('@/components/user/Register');
const ForgetPassword = () => import('@/components/user/ForgetPassword');
const Activation = () => import('@/components/user/Activation');
const ResetPassword = () => import('@/components/user/ResetPassword');
const ActivationTips = () => import('@/components/user/ActivationTips');
const Share = () => import('@/components/Share');
const ShareDetail = () => import('@/components/ShareDetail');
const News = () => import('@/components/News');
const NewDetail = () => import('@/components/NewDetail');
const Calculator = () => import('@/components/Calculator');
const Process = () => import('@/components/Process');
const PriceList = () => import('@/components/PriceList');
const Notice = () => import('@/components/Notice');
const SelfRaisingAddress = () => import('@/components/SelfRaisingAddress');
const FAQ = () => import('@/components/FAQ');
const ContactUs = () => import('@/components/ContactUs');
const Info = () => import('@/components/Info');
const Website = () => import('@/components/Website');
const Account = () => import('@/components/account/Account');
const AccountIndex = () => import('@/components/account/Index');
const Order = () => import('@/components/account/Order');
const OrderDetail = () => import('@/components/account/OrderDetail');
const CreateOrder = () => import('@/components/account/CreateOrder');
const Warehouse = () => import('@/components/account/Warehouse');
const AccountShare = () => import('@/components/account/Share');
const AccountShareList = () => import('@/components/account/ShareList');
const AccountShareComment = () => import('@/components/account/ShareComment');
const Profile = () => import('@/components/account/Profile');
const BalanceList = () => import('@/components/account/BalanceList');
const Balance = () => import('@/components/account/Balance');
const ParcelDescribe = () => import('@/components/account/ParcelDescribe');
const Referrals = () => import('@/components/Referrals');
const NotFound = () => import('@/components/NotFound');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    // eslint-disable-next-line
    $('.navbar-collapse').removeClass('in');
    if (to.meta.NonRolling) {
      return savedPosition;
    }
    return savedPosition || { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'index',
      component: Home,
      meta: {
        title: '首頁',
        keepAlive: true,
      },
    },
    // 用戶登錄
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: '登錄',
      },
    },
    {
      path: '/admin-login',
      name: 'admin-login',
      meta: {
        title: '管理員登錄',
      },
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: {
        title: '用戶註冊',
      },
    },
    {
      path: '/forget-password',
      name: 'forget-password',
      component: ForgetPassword,
      meta: {
        title: '忘記密碼',
      },
    },
    {
      path: '/activation',
      name: 'activation',
      component: Activation,
      meta: {
        title: '激活賬號',
      },
    },
    {
      path: '/reset-password/:token',
      name: 'reset-password',
      component: ResetPassword,
      meta: {
        title: '重置密碼',
      },
    },
    {
      path: '/activation-your-account',
      alias: '/thank-you-for-registered',
      name: 'activation-tips',
      component: ActivationTips,
      meta: {
        needAuthenticate: true,
        title: '發送激活郵件',
      },
    },
    {
      path: '/shares',
      name: 'shares',
      component: Share,
      meta: {
        title: '郵包分享',
      },
    },
    {
      path: '/share/:id',
      name: 'share',
      component: ShareDetail,
      meta: {
        NonRolling: true,
        title: '郵包分享詳情',
      },
    },
    {
      path: '/news',
      name: 'news',
      component: News,
      meta: {
        title: '最新消息',
      },
    },
    {
      path: '/new/:id',
      name: 'new',
      component: NewDetail,
      meta: {
        title: '文章詳細',
      },
    },
    {
      path: '/calculator',
      name: 'calculator',
      component: Calculator,
      meta: {
        title: '運費計算',
      },
    },
    {
      path: '/process',
      name: 'process',
      component: Process,
      meta: {
        title: '代運流程',
      },
    },
    {
      path: '/price-list',
      name: 'price-list',
      component: PriceList,
      meta: {
        title: '代運收費',
      },
    },
    {
      path: '/notice',
      name: 'notice',
      component: Notice,
      meta: {
        title: '注意事項',
      },
    },
    {
      path: '/self-raising-address',
      name: 'self-raising-address',
      component: SelfRaisingAddress,
      meta: {
        title: '自提地點',
      },
    },
    {
      path: '/faq',
      name: 'faq',
      component: FAQ,
      meta: {
        title: '常見問題',
      },
    },
    {
      path: '/contact-us',
      name: 'contact-us',
      component: ContactUs,
      meta: {
        title: '聯絡我們',
      },
    },
    {
      path: '/about-us',
      name: 'about-us',
      component: Info,
      meta: {
        title: '關於Uniports',
      },
    },
    {
      path: '/cooperation',
      name: 'cooperation',
      component: Info,
      meta: {
        title: '商務合作',
      },
    },
    {
      path: '/terms',
      name: 'terms',
      component: Info,
      meta: {
        title: '服務條款',
      },
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Info,
      meta: {
        title: '私隱政策',
      },
    },
    {
      path: '/websites/:zone_code',
      name: 'websites',
      component: Website,
      meta: {
        title: '推薦商戶',
      },
    },
    {
      path: '/referrals',
      name: 'referrals',
      component: Referrals,
      meta: {
        title: '分享',
      },
    },
    // 會員中心
    {
      path: '/account',
      name: 'account',
      component: Account,
      children: [
        {
          path: '/',
          name: 'account:index',
          component: AccountIndex,
          meta: {
            needAuthenticate: true,
            title: '貨品認領',
          },
        },
        {
          path: 'parcel-describe/:id',
          name: 'account:parcel-describe',
          component: ParcelDescribe,
          meta: {
            needAuthenticate: true,
            title: '郵包內含物描述',
          },
        },
        {
          path: 'order',
          name: 'account:order',
          component: Order,
          meta: {
            needAuthenticate: true,
            title: '訂單列表',
          },
        },
        {
          path: 'order/:id',
          name: 'account:order_detail',
          component: OrderDetail,
          meta: {
            needAuthenticate: true,
            title: '訂單詳情',
          },
        },
        {
          path: 'create-order',
          name: 'account:create_order',
          component: CreateOrder,
          meta: {
            needAuthenticate: true,
            title: '創建訂單',
          },
        },
        {
          path: 'warehouse',
          name: 'account:warehouse',
          component: Warehouse,
          meta: {
            needAuthenticate: true,
            title: '倉庫地址',
          },
        },
        {
          path: 'share',
          name: 'account:share',
          component: AccountShare,
          meta: {
            needAuthenticate: true,
            title: '我的分享',
          },
        },
        {
          path: 'share-list',
          name: 'account:share-list',
          component: AccountShareList,
          meta: {
            needAuthenticate: true,
            title: '分享列表',
          },
        },
        {
          path: 'share-comment',
          name: 'account:share-comment',
          component: AccountShareComment,
          meta: {
            needAuthenticate: true,
            title: '分享評論',
          },
        },
        {
          path: 'profile',
          name: 'account:profile',
          component: Profile,
          meta: {
            needAuthenticate: true,
            title: '會員資料',
          },
        },
        {
          path: 'balance',
          name: 'account:balance',
          component: Balance,
          meta: {
            needAuthenticate: true,
            title: '賬戶充值',
          },
        },
        {
          path: 'balance-list',
          name: 'account:balance-list',
          component: BalanceList,
          meta: {
            needAuthenticate: true,
            title: '充值記錄',
          },
        },
      ],
    },
    {
      path: '/404',
      name: '404',
      component: NotFound,
      meta: {
        title: '404',
      },
    },
    {
      path: '*',
      redirect: { name: '404' },
    },
  ],
});

router.beforeEach((to, from, next) => {
  const isLogined = store.getters.isLogined;
  const currentMember = store.getters.currentMember;
  if (to.path !== '/activation-your-account' && isLogined && currentMember && currentMember.status === 0) {
    next({ path: '/activation-your-account' });
    return;
  }
  // 用戶已登錄，路由需要訪客身份
  if (to.meta.needGuest && isLogined) {
    next({ path: '/' });
    return;
  }
  // 用戶未登錄，路由需要用戶身份
  if (to.meta.needAuthenticate && !isLogined) {
    next({ name: 'login' });
    return;
  }
  // 路由发生变化修改页面title
  if (to.meta.title) {
    // eslint-disable-next-line
    document.title = 'Uniports - ' + to.meta.title;
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js